import React, { Component } from 'react';
import api from "./../../../../services/api";
import './style.css';
import { NavLink } from 'react-router-dom';
import GetUserID from './GetUserID';
import { user_token } from './../../../../services/Auth';

//import da API
import { organizer } from './../../../../services/api';
let apiOrganizer = new organizer();

var token = localStorage.getItem(user_token);

//Classe para API
export default class ListaPendentes extends Component {
  constructor() {
    super();
    this.state = {
      nome: [],
      appointment_type: "",
    }
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(event) {
    this.setState({ appointment_type: event.target.value });
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    //const request = await api.get(`/exam?status=Pendente&appointment_type=${this.state.appointment_type}`, {headers: {'x-access-token': token}});
    const request = await apiOrganizer.getAllExams([
      {
        header: 'status',
        value: 'Pendente'
      },
      {
        header: 'appointment_type',
        value: this.state.appointment_type
      }
    ])
    console.log(request);
    console.log(request.data);
    this.setState({ nome: request.data });
  };

  render() {
    return (
      <>
        <div id="OG_div_filter">
          <p id="OG_title">Filtros</p>
          <select value={this.state.appointment_type} onChange={this.handleSelect} id="OG_select" required>
            <option value="">Todos</option>
            <option value="Medicina">Medicina</option>
            <option value='Psicologia'>Psicologia</option>
            <option value='Fisioterapia'>Fisioterapia</option>
            <option value='Odontologia'>Odontologia</option>
            <option value='Enfermagem'>Enfermagem</option>
            <option value='Nutrição'>Nutrição</option>
            <option value='Outros'>Outros</option>
          </select>
          <button onClick={this.loadData} id='OG_filterButton'>FILTRAR</button>
        </div>

        <div id="lista-style">
          <hr id="divider-cp-Painel" />
          <br></br>
          {this.state.nome.map(name => (
            <>
              <NavLink to={{ pathname: '/Tela_Consulta_Pendente/' + name._id }}>
                <button id="og-button" key={name._id}><GetUserID user_id={name.user_id} /></button></NavLink>
            </>
          ))}
        </div>
      </>

    );
  }

}
